export const GTM_CONFIGURATION_SET = 'GTM_CONFIGURATION_SET';
export const BOOKING_RESTARTED = 'BOOKING_RESTARTED';
export const BOOKING_CLEARED = 'BOOKING_CLEARED';
